import {RESERVED_ARG} from "../reserved-model"
import { convertToDefaultHourFormat } from "@/util"

export default class ReservedItemModel {
  constructor(item = {}) {
    this.location = item[RESERVED_ARG.LOCATION]
    this.datetime = item[RESERVED_ARG.DATETIME]
    this.quantity = item[RESERVED_ARG.QUANTITY]
    this.productName = item[RESERVED_ARG.PRODUCT_NAME]
    this.cbrUser = item[RESERVED_ARG.CBR_USER]
    this.date = item.date
    this.type = item.type
  }

  get timeHour() {
    return convertToDefaultHourFormat(this.datetime)
  }
}